<template>
  <div class="card-block">
    <h3 class="card-title">
    </h3>
    <div class="row" v-if="isLoading">
      <div class="col-md-12 card-stat">
        <loading-indicator></loading-indicator>
      </div>
    </div>
    <div class="row" v-else>
      <!-- (balances.credit - balances.usage) < 0 -->
      <div class="col-md-12" v-if="isTeamSuspend">
        <div class="alert alert-icon alert-danger alert-dismissible p-30" role="alert">
          <div class="row">
            <div class="col-md-11 clearfix">
              <div class="pull-xs-left">
                <h3 class="red-600 m-0 p-0"><i class="icon md-notifications"></i>{{ $t("suspend.labels.suspend") }}</h3>
                <p class="p-l-40 m-0" v-if="this.team.suspend.suspend_reason">{{this.team.suspend.suspend_reason}}</p>
                <p class="p-l-40 m-0" v-else>{{ $t("suspend.labels.defaultMessage") }}</p>
              </div>
            </div>
            <div class="col-md-1" v-if="!this.team.suspend.suspend_reason">
              <a class="btn btn-danger btn-lg pull-xs-right" href="#addcreditSection">{{ $t("billing.action.addCredit") }}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- For PerPaid Team -->
      <div  v-if="showCurrentCredit">
        <div class="col-md-6 col-xs-12">
          <div class="pricing-list pricing-credit text-xs-left m-b-0 card-stat">
            <div class="pricing-header"
              v-bind:class="(balances.credit >= 0) ? 'bg-blue-600' : 'bg-red-600'">
              <div class="pricing-title">{{ $t("billing.labels.remainingCredits") }}</div>
              <div class="pricing-price">
                <span class="pricing-amount">{{balances.human_credit}} {{ $t("billing.currencies.thb") }}</span>
              </div>
              <!-- check lasted transection -->
              <p class="p-x-30 p-b-25" v-if="showLastAddedCredit">{{ $t("currentCredit.lastedTransaction") }} : {{ balances.latest_refill_transaction.human_credit }} {{ $t("billing.currencies.thb") }} {{ $t("text.on") }} {{latestRefillDate}} </p>
              <p class="p-x-30 p-b-25" v-else>
                <span>{{ $t("currentCredit.textGuide") }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="bg-blue-grey-100 p-30 card-stat">
            <div class="counter counter-md text-xs-left">
              <div class="counter-label text-uppercase m-b-5">{{ $t("billing.labels.currentMonthUsage") }}
                <span v-if="showDiscount && (team.discount > 0)">({{ $t("billing.labels.perfixDiscount") }} {{ team.discount}}% {{ $t("billing.labels.subfixDiscount") }})</span>
                <span v-if="showDiscount && (team.discount <= 0)">({{ $t("billing.labels.noDiscount") }})</span>
              </div>
              <div class="counter-number-group m-b-10">
                <span class="counter-number">{{humanTotalCost}} {{ $t("billing.currencies.thb") }}</span>
              </div>
              <div class="counter-label">
                <div class="progress progress-xs m-b-10">
                  <div class="progress-ba r progress-bar-info" aria-valuemin="0"
                  aria-valuemax="100"
                  v-bind:class="(usagePercentage <= 80) ? 'bg-primary' : 'bg-danger'"
                  v-bind:style="{ width: usagePercentage + '%' }" >
                  &nbsp;
                  </div>
                </div>
                <div class="counter counter-sm text-xs-left m-t-30" v-if="showUsagePercentage">
                  <div class="counter-number-group" v-if="usagePercentage < 100">
                    <span class="counter-number" v-bind:class="(usagePercentage <= 80) ? 'blue-600' : 'red-600'">{{usagePercentage}}%</span>
                    <span class="counter-number-related">{{ $t("currentCredit.percentageBar") }}</span>
                  </div>
                  <div class="counter-number-group" v-if="usagePercentage >= 100">
                    <span class="counter-number red-600">{{ $t("monthToDateCost.creditNotEnough") }}</span>
                  </div>
                  <div class="counter-number-group m-t-10">
                    <span class="counter-number-related">{{ $t("monthToDateCost.nextCreditCharge") }} : {{upcomingBillDate}} (<a class="btn btn-link p-0" href="javascript:void(0)" v-scroll-to="'#statementSection'">{{ $t("title.statement") }}</a>)</span>
                  </div>
                </div>
                <div class="counter counter-sm text-xs-left m-t-30" v-else>
                  <div class="counter-number-group">
                    <span class="counter-number-related">{{ $t("monthToDateCost.textGuide") }}<span v-if="balances.latest_bill_id">(<a class="btn btn-link p-0" href="javascript:void(0)" v-scroll-to="'#statementSection'">{{ $t("title.statement") }}</a>)</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- For PostPaid Team -->
      <div class="col-md-12" v-else>
        <div class="p-30 bg-primary">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <div class="font-size-24 m-b-5">{{ $t("billing.labels.currentMonthUsage") }}</div>
              <div v-if="balances.upcoming_bill ? balances.upcoming_bill.total_cost > 0 : false ">
                <div class="font-size-14">{{ $t("monthToDateCost.nextCreditCharge") }}: {{upcomingBillDate}} (<a class="btn btn-link p-0" href="javascript:void(0)" v-scroll-to="'#statementSection'">{{ $t("statement.action.statement") }}</a>)</div>
              </div>
              <div v-else>
                <div class="font-size-14">{{ $t("monthToDateCost.textGuide") }} <span v-if="balances.latest_bill_id">(<a class="btn btn-link p-0" href="javascript:void(0)" v-scroll-to="'#statementSection'">{{ $t("statement.action.statement") }}</a>)</span></div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="counter counter-lg text-xs-right">
                <span class="counter-number white">{{humanTotalCost}} {{ $t("billing.currencies.thb") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    LoadingIndicator,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    team: function(value) {
      if (value) {
        this.fetchBalances();
      }
    },
  },
  computed: {
    isPrePaidTeam: function() {
      return (this.team.pay_plan === 'prepaid');
    },
    showCurrentCredit: function() {
      if (this.team.is_reseller || this.team.has_reseller) {
        return false;
      }

      if (!this.isPrePaidTeam) {
        return false;
      }

      return true;
    },
    showLastAddedCredit: function() {
      return (this.balances.latest_refill_transaction &&
              this.balances.latest_refill_transaction.created_at);
    },
    usagePercentage: function() {
      if (!this.balances.upcoming_bill) {
        return 0;
      }
      if (this.balances.credit <= 0 && this.balances.upcoming_bill.total_cost > 0) {
        return 100;
      }

      const percentage = ((this.balances.upcoming_bill.total_cost / this.balances.credit) * 100);

      if (isNaN(percentage) || !isFinite(percentage)) {
        return 0;
      }
      return parseFloat(Math.round(percentage * 100) / 100).toFixed(2);
    },
    showUsagePercentage: function() {
      if (!this.balances.upcoming_bill) {
        return false;
      }

      const percentage = ((this.balances.upcoming_bill.total_cost / this.balances.credit) * 100);

      if (!isFinite(percentage)) {
        return false;
      }

      return (this.balances.upcoming_bill.total_cost > 0);
    },
    showDiscount: function () {
      if (this.team && !this.team.has_reseller) {
        if (this.team.discount > 0) {
          return true;
        }
      }
      return false;
    },
    upcomingBillDate: function() {
      if (this.balances.upcoming_bill) {
        return moment(this.balances.upcoming_bill.will_charge_at).format('D MMM YYYY');
      } else {
        return '';
      }
    },
    humanTotalCost: function() {
      if (this.balances.upcoming_bill) {
        return this.balances.upcoming_bill.human_total_cost;
      }

      return 0.0;
    },
    latestRefillDate: function() {
      if (this.balances.latest_refill_transaction) {
        return moment(this.balances.latest_refill_transaction.created_at).format('D MMM YYYY');
      } else {
        return '';
      }
    },
    isTeamSuspend: function() {
      if (this.team) {
        if (this.team.suspend) {
          return this.team.suspend.is_suspend;
        }
      }
      return false;
    },
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', true);

    this.eventHub.$on('manualAddCreditSuccess', () => {
      this.fetchBalances();
    });
  },
  mounted: function() {
    if (this.team) {
      this.fetchBalances();
    }
  },
  data: function () {
    return {
      isLoading: false,
      balances: null,
    };
  },
  methods: {
    fetchBalances: function() {
      const namespace = this.team.namespace;

      const url = `/api/teams/${namespace}/balances`;

      axios.get(url)
      .then((response) => {
        this.balances = response.data;
        this.isLoading = false;

        this.$emit('loadChanged', false);
      })
      .catch(() => {
        this.isLoading = false;

        this.$emit('loadChanged', false);
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CurrentStat.vue?4d3b5457